import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search, ArrowRight, Users, GraduationCap, ExternalLink } from "lucide-react";
import TiltCard from "../components/TiltCard";
import PageBanner, { SectionTitle } from "../components/PageBanner";
import { colleges, stats, pageBanners } from "../data/mock";

export default function Colleges() {
  const [q, setQ] = useState("");
  const filtered = colleges.filter(c => c.name.toLowerCase().includes(q.toLowerCase()) || c.district.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="page-enter">
      <PageBanner image={pageBanners.colleges} title="College Corner" subtitle="Select a college to view its profile — students, faculty, teaching hospital and registration details." />

      <section style={{ padding: "40px 24px 60px" }}>
        <div style={{ maxWidth: 1300, margin: "0 auto" }}>
          <div className="grid-eq grid-4" style={{ display: "grid", gap: 14, marginBottom: 36 }}>
            {stats.map((s, i) => (
              <div key={s.label} className="premium-card" style={{ padding: "18px 16px", borderTop: `4px solid ${["#F97316", "#FACC15", "#DC2626", "#FB923C", "#EAB308"][i]}` }}>
                <div style={{ fontSize: 26, fontWeight: 800, color: "#C2410C" }}>{s.value.toLocaleString()}</div>
                <div style={{ fontSize: 12, color: "#78716C", marginTop: 4, fontWeight: 600 }}>{s.label}</div>
              </div>
            ))}
          </div>
          <SectionTitle>Our Medical Colleges</SectionTitle>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28, background: "#fff", padding: "6px 6px 6px 16px", borderRadius: 14, boxShadow: "0 4px 14px -6px rgba(194,65,12,0.14)", maxWidth: 500 }}>
            <Search size={18} color="#78716C" />
            <input
              data-testid="college-search-input"
              value={q} onChange={e => setQ(e.target.value)}
              placeholder="Search colleges or districts..."
              style={{ flex: 1, border: "none", outline: "none", padding: "10px 0", fontSize: 14, background: "transparent", color: "#1C1917" }}
            />
          </div>

          <div className="grid-eq grid-4" style={{ display: "grid", gap: 22 }}>
            {filtered.map(c => (
              <TiltCard key={c.slug} intensity={5}>
                <div data-testid={`college-item-${c.slug}`} style={{ height: 180, overflow: "hidden", borderTopLeftRadius: 20, borderTopRightRadius: 20 }}>
                  <img src={c.img} alt={c.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>
                <div style={{ padding: 22 }}>
                  <div style={{ fontSize: 11, color: "#EA580C", letterSpacing: 1.2, fontWeight: 700 }}>{c.district}</div>
                  <h3 className="font-serif college-corner-name" style={{ fontSize: 18, color: "#1C1917", marginTop: 6, fontWeight: 700 }}>{c.name}</h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 16, paddingTop: 16, borderTop: "1px solid rgba(194,65,12,0.1)" }}>
                    <div><div style={{ fontSize: 16, fontWeight: 700, color: "#C2410C" }}>{c.seats}</div><div style={{ fontSize: 10, color: "#78716C" }}>MBBS Seats</div></div>
                    <div><div style={{ fontSize: 16, fontWeight: 700, color: "#C2410C" }}>{c.students}</div><div style={{ fontSize: 10, color: "#78716C" }}>Students</div></div>
                  </div>
                  <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
                    <Link to={`/colleges/${c.slug}`} style={{ textDecoration: "none", flex: 1 }}>
                      <button className="btn-primary-3d" style={{ width: "100%", padding: "10px 14px", fontSize: 13 }}>View <ArrowRight size={12} style={{ marginLeft: 4, verticalAlign: "middle" }} /></button>
                    </Link>
                    <a href={c.website} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                      <button className="btn-outline-3d" style={{ padding: "10px 12px", fontSize: 13 }}><ExternalLink size={12} /></button>
                    </a>
                  </div>
                </div>
              </TiltCard>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
